import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-collapse-button',
    templateUrl: './collapse-button.component.html',
    styleUrls: ['./collapse-button.component.scss'],
    standalone: false
})
export class CollapseButtonComponent implements OnInit {
    @Input() openAll = false;
    @Output() handleCollapse = new EventEmitter<boolean>();

    constructor(
    ) { }

    ngOnInit(): void {
    }

    onHandleCollapse(){
        this.openAll = !this.openAll;
        this.handleCollapse.emit(this.openAll);
    }
}
